import {TooltipForChild, XRow, XText, XTextButton, cx, xcolors} from "@cdx/common";
import {enrichCardProjectTags} from "../../components/Markdown/CardTags";
import {lazy} from "react";
import {DSIconCrown, Row} from "@cdx/ds";
import UnMarkedown from "../../components/Markdown/UnMarkedown";
import {parentPillSyles as styles} from "./unified-card-container.css";
import cardStyles from "../../components/Card/card.css";
import {getChildCardInfo} from "../workflows/workflow-utils";
import {cardStatusVariants} from "@cdx/ds/components/DSCard/DSCardTheme.css";
import {useDSComputeWithDimensions} from "@cdx/ds/hooks/position-hooks";

const LazyWorkflowHoverInfo = lazy(
  () => import(/* webpackChunkName: "WorkflowOverInfo" */ "../workflows/WorkflowHoverInfo")
);

export const CardParentPill = ({parent, onClick, childCardPanelOpen, arenaCtx, root}) => {
  const {getCardUrl} = arenaCtx.routes;
  const emojis = enrichCardProjectTags(parent)
    .map((t) => t.emoji)
    .filter(Boolean)
    .join("");
  const shownTitle = parent.title && emojis ? `${emojis} ${parent.title}` : parent.title;
  const info = getChildCardInfo(parent, root.account);

  const [chartRef, needStripes] = useDSComputeWithDimensions((dims) => {
    if (!dims || !info) return true;
    return dims.width / info.count > 8;
  });

  return (
    <TooltipForChild
      tooltip={() => <LazyWorkflowHoverInfo hideParent card={parent} />}
      placement="right"
      bg="gray800"
      distanceFromAnchor={10}
      hidden={childCardPanelOpen}
    >
      <XRow
        noShrink
        align="center"
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
        className={cx(styles.base, styles.types.golden, cardStatusVariants.hero)}
      >
        <XTextButton
          to={getCardUrl({card: parent})}
          square
          tooltip="Open Hero card"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <DSIconCrown size={16} style={{color: xcolors.white}} />
        </XTextButton>
        <XText noOverflow preset="bold" size={3} color={null}>
          <UnMarkedown projectId={parent.deck && parent.deck.project.id}>{shownTitle}</UnMarkedown>
        </XText>
        <Row
          rounded={4}
          height="4px"
          overflow="hidden"
          relative
          top="1px"
          flex="auto"
          className={
            needStripes
              ? cardStyles.childCardInfo.sectionCount.md
              : cardStyles.childCardInfo.sectionCount.lg
          }
          ref={chartRef}
        >
          {info &&
            ["done", "review", "blocked", "started", "rest"].flatMap((label) =>
              info[label].map((effort, idx) => (
                <div
                  key={`${label}-${idx}`}
                  style={{flex: `1px ${(effort || 0) + 1}`}}
                  className={cx(
                    cardStyles.childCardInfoBarTile.base,
                    label !== "rest" && cardStyles.childCardInfoBarTile[label]
                  )}
                />
              ))
            )}
        </Row>
      </XRow>
    </TooltipForChild>
  );
};
